<div [class.hidden]="!parentOpenState" class="panel-wrapper">
  <mat-expansion-panel [expanded]="panelOpenState"
                       (opened)="handleOpened()"
                       (closed)="handleClosed()"
                       hideToggle="true"
                       id="{{config.title | stripSpecialChars}}-goal"
                       class="sub-panel mt-3 overflow-visible">
    <mat-expansion-panel-header tabindex="-1" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="taxanomy-header p-0">
      <mat-panel-title class="align-items-center">
        <div [style.background-color]="color" class="taxanomy-number text-center row align-items-center">
          <span>{{config.title}}</span>
        </div>
        <span class="panel-header-text">
          <app-dynamic-content
            [contentId]="'action-taxonomy-goal-desc'"
            [htmlContent]="config.description">
          </app-dynamic-content>
        </span>
        <div class="arrows" tabindex="0">
          <svg [style.fill]="color" class="taxanomy-arrow-up" *ngIf="panelOpenState" xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
            <path class="a"
                  d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
                  transform="translate(49.61 49.61) rotate(180)" />
          </svg>

          <svg [style.fill]="color" class="taxanomy-arrow-down" *ngIf="!panelOpenState" xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
            <path class="a"
                  d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
                  transform="translate(0)" />
          </svg>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <kla-action-plan-sub-subpanel
      [columnNames]="columnNames"
      [columnsActive]="columnsActive"
      [categories]="categories"
      [config]="config.include"
      [color]="color"
      [collapseChildren]="collapseChildren">
    </kla-action-plan-sub-subpanel>
  </mat-expansion-panel>
</div>
